import React from 'react'
import currencyFormater from 'currency-formatter'
import * as XLSXStyle from 'xlsx-js-style';
import { cpf } from 'cpf-cnpj-validator';
import { cnpj } from 'cpf-cnpj-validator';
import { Dropdown } from 'primereact/dropdown';
import replaceSpecialCharacters from 'replace-special-characters'
import { InputNumber } from 'primereact/inputnumber';
import ConstantsUtil from '../../context/constantsUtil';
import * as popUp from '../../components/toastr'
import { Button } from 'primereact/button';
import TooltipButton from '../../components/tooltipButton';
import ProvisaoService from './contasAPagar/provisaoService';
import HandleErrorService from './handleErrorService';
import EmpresaService from './central/empresaService';
import SystemDataService from './systemDataService';
import CentralService from './central/centralService';
import { classNames } from 'primereact/utils';
import ConfiguracaoEmpresaService from './configuracaoEmpresaService';
import NFService from './estoque/NFService';
import ComponenteDigitalService from './componenteDigitalService';
import AuthService from './authService';
import PreferenciasUsuarioService from './preferenciasUsuarioService';

class GeneralServices extends React.Component {

    constructor(){
        super()
        this.provisaoService = new ProvisaoService()
        this.empresaService = new EmpresaService()
        this.NFService = new NFService()
        this.systemDataService = new SystemDataService()
        this.centralService = new CentralService()
        this.configuracaoEmpresaService = new ConfiguracaoEmpresaService()
        this.componenteDigitalService = new ComponenteDigitalService()
        this.preferenciasUsuarioService = new PreferenciasUsuarioService()
    }
    
    sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    static showFormattedIfNonZero = (value, formatted, withColor) => {
        /*
        Se formatted for true, a visualização fica como se fosse dinheiro: R$30,00
        */
        if(value === 0 || value === null || typeof value === 'undefined' || isNaN(value))
            return ''
        if(formatted){
            if(withColor){
                const classes = classNames({
                    'superavitValue': withColor && (value && value > 0),
                    'deficitValue': withColor && (value && value < 0),
                    
                });
                return (
                    <div className={classes}>
                        {this.valueBodyTemplate(value)}
                    </div>
                )
            }
            return this.valueBodyTemplate(value)
        }
        return value
    }

    static showFormattedIfNotNull = (value, formatted = true, withColor) => {
        /*
        Se formatted for true, a visualização fica como se fosse dinheiro: R$30,00
        */
        if(value === null || typeof value === 'undefined' || isNaN(value)) {
            return ''

        }
        if(formatted){
            if(withColor){
                const classes = classNames({
                    'superavitValue': (value && value > 0),
                    'deficitValue': (value && value < 0),
                    // 'small-table-font': (Math.abs(value) > 1000000)
                    
                });
                return (
                    <div className={classes}>
                        {this.valueBodyTemplate(value)}
                    </div>
    
                )
            }
            return this.valueBodyTemplate(value)
        }
        return value
    }

    static valueBodyTemplate = (value) => {
        // return currencyFormater.format(value, {locale: 'pt-BR', code: false} )
        let formattedValue = currencyFormater.format(value, {locale: ''})
        formattedValue = formattedValue.replaceAll(",", "#").replace(".", ",").replaceAll("#", ".")
        return formattedValue
    }

    static valueBodyTemplateWithCifrao = (value) => {
        // return currencyFormater.format(value, {locale: 'pt-BR', code: false} )
        let formattedValue = currencyFormater.format(value, {locale: ''})
        formattedValue = formattedValue.replaceAll(",", "#").replace(".", ",").replaceAll("#", ".")
        return `R$ ${formattedValue}`
    }

    static getCurrentYear = () => {
        return new Date().getFullYear()
    }

    static convertToUsDate = (date) => {
        /*
        Converte "dd-MM-yyyy" em "MM-dd-yyyy"
        */
        if(!date) return ''
        var dateArray = date.split('-')
        return dateArray[1] + '-' + dateArray[0] + '-' + dateArray[2]
    }

    static convertToBrDate = (date) => {
        /*
        Converte yyyy-dd-MM em dd-MM-yyyy
        */
        var dateArray = date.split('-')
        return dateArray[1] + '-' + dateArray[2] + '-' + dateArray[0]
    }

    static getNowDateAsString(){
        return this.convertJSDateToBrDate(new Date())
    }

    static convertJSDateToBrDate(primereactDate){

        /*
            Sat Nov 01 2025 00:19:00 GMT-0300 -> 01/11/2025
        */

        if(primereactDate === null){
            return ''
        }
        var jsDate = new Date(primereactDate)
        var initialDayOfMonth = jsDate.getDate()
        var dayOfMonth = parseInt(initialDayOfMonth) < 10 ? "0" + initialDayOfMonth : initialDayOfMonth
        
        var initialMonth = parseInt(jsDate.getMonth()) + 1 //getMonth() retorna de 0-11
        var month = initialMonth < 10 ? "0" + initialMonth.toString() : initialMonth.toString()
        
        var year = jsDate.getFullYear()

        var brDate = dayOfMonth + "-" + month + "-" + year
        return brDate
    }

    static isoDateToBrDateWithHour(isoString) {

        /*
        2025-11-01T03:19:20.000+00:00 -> 01/11/2025 03:19:20
        */

        const date = new Date(isoString);

        const pad = (n) => n.toString().padStart(2, "0");

        return (
            pad(date.getDate()) +
            "/" +
            pad(date.getMonth() + 1) +
            "/" +
            date.getFullYear() +
            " " +
            pad(date.getHours()) +
            ":" +
            pad(date.getMinutes()) +
            ":" +
            pad(date.getSeconds())
        );
    }

    static proximosDiasDoMes(diaD, quantidadeMeses, dataBase = new Date()) {
        // Cria array para armazenar as datas resultantes
        const resultados = [];
        // Garante que dataBase será somente a Data, sem horário
        dataBase = new Date(dataBase.getFullYear(), dataBase.getMonth(), dataBase.getDate());

        // Determina o mês/ano inicial para considerar
        let ano = dataBase.getFullYear();
        let mes = dataBase.getMonth(); // Janeiro = 0

        // Determina o primeiro diaD possível: se ainda não passou no mês atual, começa desse mês
        if (dataBase.getDate() < diaD) {
            // OK: próximo diaD é neste mês
        } else {
            // Já passou, tem que pular o mês
            mes += 1;
            if (mes > 11) {
            mes = 0;
            ano += 1;
            }
        }

        // Gera os X próximos dias D de cada mês
        for (let i = 0; i < quantidadeMeses; i++) {
            // Cria a nova data
            // Usar o mínimo entre diaD e 28/29/30/31 para não cair em datas inválidas
            const ultimoDiaDoMes = new Date(ano, mes + 1, 0).getDate();
            const dia = Math.min(diaD, ultimoDiaDoMes);
            resultados.push(new Date(ano, mes, dia));

            // Próximo mês
            mes += 1;
            if (mes > 11) {
                mes = 0;
                ano += 1;
            }
        }

        return resultados;
    }

    static getCurrentDay(){
        let date = new Date()
        return date
    }

    static getAddedDays(daysToBeAdded){
        let date = new Date()
        date.setDate(date.getDate() + daysToBeAdded)
        return date
    }

    
    static formatDateFromFichaDeEstoque(data){
        /*
            Transforma 2023-07-01T00:00:00 em 01-07-2023
        */
        const newData = data.split("T")[0]
        var newDataArray = newData.split("-")
        newDataArray = newDataArray.reverse()
        return newDataArray.join("-")
    }

    static convertBrStringToJsDate(stringBrDate){
        /*
        Recebe "dd-MM-yyyy" e transforma em JSDate
         */

        if(!stringBrDate){
            return null
        }

        var dateArray = stringBrDate.split('-')
        return new Date(dateArray[1] + '-' + dateArray[0] + '-' + dateArray[2])
    }

    static convertCompleteBrStringToJsDate(stringBrDate){
        /*
        Converte string no padrão "dd-MM-yyyy - HH:mm" em Date js
        */

        // Divide a string em partes usando regex que já pega espaços, traços e dois pontos
        var partes = stringBrDate.split(/[\s:-]+/);
        // console.log("partes:", partes)

        // Obtém as partes relevantes da data e hora
        var dia = parseInt(partes[0], 10);
        var mes = parseInt(partes[1], 10) - 1; // Os meses em JavaScript são de 0 a 11
        var ano = parseInt(partes[2], 10);
        var horas = parseInt(partes[3], 10);
        var minutos = parseInt(partes[4], 10);

        // Cria um objeto Date com as partes extraídas
        // console.log("ano, mes, dia, horas, minutos: ", ano, mes, dia, horas, minutos)
        var data = new Date(ano, mes, dia, horas, minutos);
        // console.log("data final: ", data)
        return data;
    }

    static checkValidHour = (hour) => {
        var checkHour = false
        var checkMinutes = false
        var length = hour ? hour.length === 5 : null
        if(length){
            var hourArray = hour.split(':')
            var intHour  = parseInt(hourArray[0], 10)
            var minutes = parseInt(hourArray[1], 10)
            if(intHour>=0 && intHour<24){
                checkHour=true
            }
            if(minutes>=0 && minutes<=60){
                checkMinutes=true
            }
        }
        return length && checkHour && checkMinutes
    }

    static compareIntValues( product1, product2 ) {
        var value1 = parseInt(product1.value, 10)
        var value2 = parseInt(product2.value, 10)
        if ( value1 < value2 ){
          return -1;
        }
        if ( value1 > value2){
          return 1;
        }
        return 0;
    }

    static compareGenericValues(item1, item2){
        /*
        Se os valores informados forem numbers, então ordenará em ordem crescente dos valores.
        Caso sejam strings, ordenará em ordem alfabética crescente, sabendo tratar caracteres com acento agudo e etc.
        */
        var value1 = item1.label
        var value2 = item2.label

        if(typeof(value1) === 'string' && typeof(value2) === 'string'){
            return value1.localeCompare(value2, 'pt-BR')
        }

        if ( value1 < value2 ){
          return -1;
        }
        if ( value1 > value2){
          return 1;
        }
        return 0;
    }

    static compareTimestampByIncreasing(moviment1, moviment2){
        const value1 = moviment1.timestamp
        const value2 = moviment2.timestamp
        
        if ( value1 < value2 ){
            return -1;
        }
        else if ( value1 > value2){
            return 1;
        }   else { //mesmo dia (mesmo timestamp)
                const desempate1 = moviment1.desempate
                const desempate2 = moviment2.desempate

                if ( desempate1 < desempate2 ){
                    return -1;
                }
                else if ( desempate1 > desempate2){
                    return 1;
                } else{
                    // console.log('algo de errado')
                }
            }
    }

    // static sortStockSheet(productStockSheet){

    //     productStockSheet.sort(this.compareTimestampByIncreasing)

    //     return productStockSheet
    // }

    // static calculateBalance(productStockSheet){
    //     productStockSheet = this.sortStockSheet(productStockSheet)
    //     for(var i=0; i<productStockSheet.length; i++){
    //         var moviment = productStockSheet[i]
    //         if(moviment.tipoAtualizacao !== 'MANUAL') {
    //             var previousMoviment = productStockSheet[i-1]
    //             if(previousMoviment && previousMoviment.quantidadeSaldo !== null && typeof previousMoviment.quantidadeSaldo !== "undefined"){
    //                 moviment.quantidadeSaldo = previousMoviment.quantidadeSaldo + moviment.quantidadeEntrada - moviment.quantidadeSaida
                    
    //                 var previousValorTotalSaldo = 0
    //                 if(previousMoviment.valorTotalSaldo !== null && typeof previousMoviment.valorTotalSaldo !== "undefined"){
    //                     previousValorTotalSaldo = previousMoviment.valorTotalSaldo
    //                 }
    //                 moviment.valUnitSaida = moviment.quantidadeSaida ===0 ? 0 : 
    //                     parseFloat((previousValorTotalSaldo/previousMoviment.quantidadeSaldo).toFixed(2))

    //                 moviment.valUnitEntrada = moviment.quantidadeEntrada ===0 ? 0 :
    //                     parseFloat((moviment.valorTotalEntrada/moviment.quantidadeEntrada).toFixed(2))
                    
    //                 moviment.valorTotalSaldo = 
    //                     parseFloat((previousValorTotalSaldo + moviment.valUnitEntrada*moviment.quantidadeEntrada
    //                         - moviment.valUnitSaida*moviment.quantidadeSaida).toFixed(2))
    //             }
    //         } else{ //Moviment Manual
    //             moviment.valorTotalSaldo = moviment.valorTotalEntrada
    //         }
    //     }
    //     return productStockSheet.reverse()
    // }

    static adjustNCM = (ncm) => {
      if(ncm === 0){ 
          return '00000000'
      }
      else{
          return ncm
      }
    }

    static minMaxYearRange(){
        //pega ano atual e 5 pra trás
        const today = new Date()
        const nextYear = today.getFullYear()+1
        const minYear = nextYear-5
        return {minYear: minYear, nextYear: nextYear}
    }

    static yearRange(){
        const yearObj = this.minMaxYearRange()
        var yearRange= yearObj.minYear + ":" + yearObj.nextYear
        return yearRange
    }

    static selectYearRange(){
        const yearObj = this.minMaxYearRange()
        var yearSelectList=
        [
            {label: yearObj.nextYear, value: yearObj.nextYear},
        ]
        for(var i = yearObj.nextYear-1; i >= yearObj.minYear; i--){
            yearSelectList.push({label: i, value: i})
        }
        return yearSelectList
    }

    static validarCPFOuCNPJ(cpfOuCnpj){
        const CPF = cpf.isValid(cpfOuCnpj)
        const CNPJ = cnpj.isValid(cpfOuCnpj)
        return CPF || CNPJ
    }

    static tablePaginatorTemplate(initialValue, totalRecords){
        return this.tablePaginatorSpecific(initialValue, 300, totalRecords)
        // return {
        //     layout:
        //         'FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown',
        //         'RowsPerPageDropdown': (options) => {
        //             const dropdownOptions = [
        //                 { label: initialValue, value: initialValue },
        //                 { label: 300, value: 300 },
        //                 { label: 'Tudo', value: totalRecords}
        //             ];

        //         return <Dropdown value={options.value} options={dropdownOptions} onChange={options.onChange} appendTo={document.body} />;
        //     }
        // }
    }

    static tablePaginatorDropdownOptions = (initialValue, intermediateValue, maxValue) => {
        let initObj = { label: initialValue, value: initialValue }
        if(initialValue === maxValue){
            return [initObj]
        }
        return [
            initObj,
            { label: intermediateValue, value: intermediateValue },
            { label: maxValue, value: maxValue}
        ];
    }

    static tablePaginatorSpecific(initialValue, intermediateValue, maxValue){
        return {
            layout:
                'FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown',
                'RowsPerPageDropdown': (options) => {
                    const dropdownOptions = this.tablePaginatorDropdownOptions(initialValue, intermediateValue, maxValue)
                    // const dropdownOptions = [
                    //     { label: initialValue, value: initialValue },
                    //     { label: intermediateValue, value: intermediateValue },
                    //     { label: maxValue, value: maxValue}
                    // ];

                return <Dropdown value={options.value} options={dropdownOptions} onChange={options.onChange} appendTo={document.body} />;
            }
        }
    }

    static getContaBancariaOrigemOuDestinoLabel = (invert, isTipoDeLancamentoTransferencia, isTipoDeLancamentoTransferenciaEntrada) => {
        const defaultLabel = 'Conta Bancária'
        const destinoLabel = defaultLabel + ' de Destino'
        const origemLabel = defaultLabel + ' de Origem'

        if(isTipoDeLancamentoTransferencia()){

            if(isTipoDeLancamentoTransferenciaEntrada()){
                if(invert){
                    return destinoLabel
                }

                return origemLabel
            }
            else{
                if(invert){
                    return origemLabel
                }
                return destinoLabel
            }
    }

        return defaultLabel
    }

    static replaceSpecialCharacters(string){
        if(string){
            return replaceSpecialCharacters(string.toString())
        }
    }

    static replaceSpecialCharactersForSearch(stringToReplace, searchString){
        // console.log("searchString: ", searchString)
        // console.log("compare: ", JSON.stringify(searchString) === JSON.stringify([]), JSON.stringify(searchString) === JSON.stringify([""]))
        if(searchString === '' || searchString === undefined || searchString === null || JSON.stringify(searchString) === JSON.stringify([]) || JSON.stringify(searchString) === JSON.stringify([""])){
            // console.log("sem replace")
            if(stringToReplace){
                return stringToReplace.toString()
            }
            return stringToReplace
        }
        // console.log("replace")
        return replaceSpecialCharacters(stringToReplace.toString())
    }

    static includeString(string, substring){
        if(!string){
            return false
        }
        return replaceSpecialCharacters(string.toString().toLowerCase()).includes(replaceSpecialCharacters(substring.toString().toLowerCase()))
    }

    static equalsString(string1, string2){
        return (replaceSpecialCharacters(string1.toString().oLowerCase()) === replaceSpecialCharacters(string2.toString().toLowerCase()))
    }

    static contaBancariaFormattedNameInDRE(dreSaldoBancarioDTO){
        const contaBancaria = dreSaldoBancarioDTO.contaBancaria
        var label;
        if(contaBancaria.descricao){
            label = contaBancaria.descricao
        }
        else if(contaBancaria.numAgencia) {
            label = contaBancaria.nomeBanco + " - AG: " + contaBancaria.numAgencia + " - Conta: " + contaBancaria.numConta + "-" + contaBancaria.numDigitoConta;
        }
        else{
            label = contaBancaria.nomeBanco;
        }

        const nomeEmpresa = dreSaldoBancarioDTO.empresa
        if(nomeEmpresa){
           label = label.concat(" (", nomeEmpresa, ")")
        }

        return label

    }

    static inputTableNumber(id, name, value, rowData, handleTableChange, placeholder, disabled, onBlurFucntion, onKeyDownFunction){
        return (
            <InputNumber
                id={id}
                name={name}
                placeholder={placeholder ? placeholder : 'Informe o valor'}
                value={value}
                mode="decimal"
                onBlur={() => {
                    // console.log("onBlur")
                    if(onBlurFucntion){
                        onBlurFucntion()
                    }
                }}
                onKeyDown={(event) => {
                    // console.log("onKeyDown")
                    if(onKeyDownFunction){
                        onKeyDownFunction(event)
                    }
                }}
                inputClassName={ConstantsUtil.inputNumberSmallClass} 
                minFractionDigits={2} maxFracionDigits={2}
                onValueChange={(event) => handleTableChange(event, rowData)}
                disabled={disabled}
            />
        )
    }

    static saveAsExcelFile(workbook, fileName) {
        import('file-saver').then(module => {
            if (module && module.default) {
                // const excelBuffer = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
                const excelBuffer = XLSXStyle.write(workbook, { bookType: 'xlsx', type: 'array' });

                // let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
                let EXCEL_EXTENSION = '.xlsx';

                // const data = new Blob([excelBuffer], {
                //     type: EXCEL_TYPE
                // });
                const data = new Blob([excelBuffer], { type: 'application/octet-stream' });

                module.default.saveAs(data, fileName + EXCEL_EXTENSION);
            }
        });
    }

    static jsonToSheet(formattedList) {
        // const worksheet = xlsx.utils.json_to_sheet(formattedList);
        const worksheet = XLSXStyle.utils.json_to_sheet(formattedList);
        
        // Obtém as chaves dos headers (primeira linha)
        const headers = Object.keys(formattedList[0] || {});
    
        // Calcula a largura máxima de cada coluna, incluindo o header de forma que nenhuma coluna fique com dados ocultos/cortados.
        const colWidths = formattedList.reduce((widths, row) => {
            return headers.map((header, i) => {

                let minWidth = 15

                const valueLength = row[header] ? row[header].toString().length : minWidth;
                const headerLength = header.length;
                // Considera o maior valor entre o tamanho do header e do valor da célula
                return Math.max(widths[i] || minWidth, valueLength, headerLength);
            });
        }, []);
    
        // Aplica as larguras calculadas no sheet
        worksheet['!cols'] = colWidths.map(w => ({ wch: w }));
    
        return worksheet;        
    }    

    static exportPdf = (filename, exportColumns, list) => {
        // var exportColumns = this.state.columns.map(col => ({ title: col.header, dataKey: col.field }))
        // var list = this.props.notFilteredList
        import('jspdf').then(jsPDF => {
            import('jspdf-autotable').then(() => {
                const doc = new jsPDF.default(0, 0);
                doc.autoTable(exportColumns, list);
                doc.save(filename);
            })
        })
    }

    static generateWorkSheet(list){
        const worksheet = GeneralServices.jsonToSheet(list);
        return worksheet
    }    

    static generateWorkbook = (list, sheetName, headersMoeda = [], headersAlignRight = []) => {
        let worksheet = this.generateWorkSheet(list)
        this.formataHeaderExportacao(worksheet)
        this.formataColunaValorExportacao(list, worksheet, headersMoeda)
        this.formataAlignRight(list, worksheet, headersAlignRight)
        const workbook = { Sheets: { [sheetName]: worksheet }, SheetNames: [[sheetName]] };
        return workbook
    }

    static exportExcel = (list, sheetName, filename, headersMoeda = [], headersAlignRight = []) => {
        let workbook = this.generateWorkbook(list, sheetName, headersMoeda, headersAlignRight)
        this.saveAsExcelFile(workbook, filename);
    }

    static formataHeaderExportacao(worksheet){

        /*
            Centraliza header e deixa em negrito.
        */

        // Garante que há um range definido
        const range = XLSXStyle.utils.decode_range(worksheet['!ref']);

        // Itera todas as colunas do range na primeira linha (r = 0)
        for (let c = range.s.c; c <= range.e.c; c++) {
            const cellAddress = XLSXStyle.utils.encode_cell({ r: 0, c });
            const cell = worksheet[cellAddress];
            if (!cell) continue; // se não existe célula nessa coluna da linha 0, segue

            // Mescla com estilo existente (se houver) para não perder outros atributos
            const prevStyle = cell.s || {};
            cell.s = {
                ...prevStyle,
                font: { ...(prevStyle.font || {}), bold: true },
                alignment: { ...(prevStyle.alignment || {}), horizontal: "center", vertical: "center" },
            };
        }
    }

    static formataAlignRight(listFinalToExport, worksheet, headersAlignRight = []) {

        if (!listFinalToExport?.length) return;

        // console.log("headersMoeda: ", headersMoeda)

        // Descobre os headers e quantas colunas existem
        const headers = Object.keys(listFinalToExport[0]);
        const totalCols = headers.length;

        const alvo = new Set(
            headers
            .map((h, idx) => ({ h: String(h).trim(), idx }))
            .filter(({ h }) => headersAlignRight.some(alvo => h.includes(String(alvo).trim())))
            .map(({ idx }) => idx)
        );

        // Percorre as linhas de dados
        listFinalToExport.forEach((item, index) => {
            const excelRow = index + 2; // linha 1 é o cabeçalho

            for (let colIndex = 0; colIndex < totalCols; colIndex++) {
                const cellAddress = XLSXStyle.utils.encode_cell({ r: excelRow - 1, c: colIndex });
                const cell = worksheet[cellAddress];
                if (!cell) continue;

                // Se a coluna está nas de moeda, aplica o formato
                if (alvo.has(colIndex)) {
                    cell.s = {
                        alignment: {
                            horizontal: "right"
                        }
                    };
                }

            }
        });
    }

    static formataColunaValorExportacao(listFinalToExport, worksheet, headersMoeda = []) {
        if (!listFinalToExport?.length) return;

        // console.log("headersMoeda: ", headersMoeda)

        // Descobre os headers e quantas colunas existem
        const headers = Object.keys(listFinalToExport[0]);
        const totalCols = headers.length;

        /*
        Normaliza a lista de headers de moeda (ex.: ["Valor Total", "Total", "Preço"])
        e cria um Set de índices de coluna que devem receber formatação de moeda
        */
        const alvo = new Set(
            headers
            .map((h, idx) => ({ h: String(h).trim(), idx }))
            .filter(({ h }) => headersMoeda.some(alvo => String(alvo).trim() === h))
            .map(({ idx }) => idx)
        );

        // Percorre as linhas de dados
        listFinalToExport.forEach((item, index) => {
            const excelRow = index + 2; // linha 1 é o cabeçalho

            for (let colIndex = 0; colIndex < totalCols; colIndex++) {
                const cellAddress = XLSXStyle.utils.encode_cell({ r: excelRow - 1, c: colIndex });
                const cell = worksheet[cellAddress];
                if (!cell) continue;

                // Se a coluna está nas de moeda, aplica o formato
                if (alvo.has(colIndex)) {
                    cell.z = '"R$"#,##0.00';
                }
            }
        });
    }

    static copyChNFeBody(chave) {
        return (
            <React.Fragment>
                <TooltipButton
                    tooltip = {chave}
                    icon="pi pi-copy"
                    // className="p-button-rounded p-button-primary p-mr-2"
                    style={ {maxHeight: '25px', maxWidth: '25px'} }
                    onClick={() => {this.onClickCopyValueFunction(chave, "Chave copiada!", false)}}
                />
            </React.Fragment>
        );        
    }

    static onClickCopyValueFunction = (valor, mensagem, formatValue) => {
        let valorFinal = formatValue ? this.formatTo2CasasDecimais(valor) : valor
        navigator.clipboard.writeText(valorFinal)
        popUp.infoPopUp(mensagem)
    }

    static trataDadosNF =  (notasFiciaisList) => {
        notasFiciaisList.forEach(notaFiscal => {
            this.trataSituacaoNF(notaFiscal)
        })
        this.dealNFListDates(notasFiciaisList)
    }

    // static trataTipoDreCompetenciaLabel = (tipoDreCompetencia) => {
    //     const map = new Map([
    //         [ConstantsUtil.DRECompetenciaGrupoCMV, ConstantsUtil.DRECompetenciaGrupoCMV],
    //         [ConstantsUtil.DRECompetenciaGrupoDespesasPessoal, ConstantsUtil.DRECompetenciaGrupoDespesasPessoalLabel],
    //         [ConstantsUtil.DRECompetenciaGrupoDespesasFuncionamento, ConstantsUtil.DRECompetenciaGrupoDespesasFuncionamentoLabel],
    //         [ConstantsUtil.DRECompetenciaGrupoOutrasDespesas, ConstantsUtil.DRECompetenciaGrupoOutrasDespesasLabel],
    //     ]);

    //     return map.get(tipoDreCompetencia)
    // }

    static tipoDreCompetenciaGrupoDePagamentoSelectList = () => {
        return [
            {label: 'Selecione...', value: ''},
            {label: ConstantsUtil.DRECompetenciaGrupoCMV, value: ConstantsUtil.DRECompetenciaGrupoCMV},
            {label: ConstantsUtil.DRECompetenciaGrupoDespesasPessoalLabel, value: ConstantsUtil.DRECompetenciaGrupoDespesasPessoal},
            {label: ConstantsUtil.DRECompetenciaGrupoDespesasFuncionamentoLabel, value: ConstantsUtil.DRECompetenciaGrupoDespesasFuncionamento},
            {label: ConstantsUtil.DRECompetenciaGrupoOutrasDespesasLabel, value: ConstantsUtil.DRECompetenciaGrupoOutrasDespesas},
        ]
    }

    static trataSituacaoNF = (notaFiscal) => {
        switch(notaFiscal.situacao){
            case ConstantsUtil.situacaoRegular:
                notaFiscal.situacaoLabel = notaFiscal.pendente ? ConstantsUtil.situacaoRegularAguardandoValidacaoLabel : ConstantsUtil.situacaoRegularValidadaLabel
                break;
            case ConstantsUtil.situacaoCancelada:
                notaFiscal.situacaoLabel = ConstantsUtil.situacaoCanceladaLabel
                break;
            case ConstantsUtil.situacaoExcluida:
                notaFiscal.situacaoLabel = ConstantsUtil.situacaoExcluidaLabel
                break;
            default:
                notaFiscal.situacaoLabel = notaFiscal.situacao
                break;
        }        
    }

    static mensagemComposicaoValorTotal = transaction => {
        // console.log("transaction: ", transaction)
        return `Composição do ${ConstantsUtil.valorTotalProdutoNaNFLabel}:
        Valor do Produto: ${this.formatTo2CasasDecimais(transaction.vprod)} (+)
        Valor de Acréscimo: ${this.formatTo2CasasDecimais(transaction.vacrescimo)} (+)
        Valor de Desconto: ${this.formatTo2CasasDecimais(transaction.vdesc)} (-)
        Valor de Frete: ${this.formatTo2CasasDecimais(transaction.vfrete)} (+)
        Valor de ICMSST: ${this.formatTo2CasasDecimais(transaction.vicmsst)} (+)
        Valor de FCPST: ${this.formatTo2CasasDecimais(transaction.vfcpst)} (+)
        Valor de IPI: ${this.formatTo2CasasDecimais(transaction.vipi)} (+)
        Outros: ${this.formatTo2CasasDecimais(transaction.voutro)} (+)
        Valor Final do Produto: ${this.formatTo2CasasDecimais(transaction.valor)} (=)
        `
    }

    static dealNFListDates = (NFList) => {
        NFList.forEach(item => {
            
            //Seta Valores Padrão
            item.dEmiSemHorario = ''
            item.dhEmiJsDate = ''

            item.dataHoraImportacaoSemHorario = ''
            item.dataHoraImportacaoJsDate = ''

            item.dataEntradaSemHorario = ''
            item.dataEntradaJsDate = ''

            item.dataCompetenciaJsDate = ''

            item.dataImportacaoSemHorario = ''
            item.dataHoraImportacaoJsDate = ''

            item.dataHoraValidacaoSemHorario = ''
            item.dataHoraValidacaoJsDate = ''

            item.dataHoraUltimaAcaoUsuarioSemHorario = ''
            item.dataHoraUltimaAcaoUsuarioJsDate = ''

            if(item.dhEmi){
                item.dEmiSemHorario = item.dhEmi.split(" -")[0]
                item.dhEmiJsDate = this.convertCompleteBrStringToJsDate(item.dhEmi).getTime()
            }

            if(item.dataHoraImportacao){
                item.dataHoraImportacaoSemHorario = item.dataHoraImportacao.split(" -")[0]
                item.dataHoraImportacaoJsDate = this.convertCompleteBrStringToJsDate(item.dataHoraImportacao).getTime()
            }

            if(item.dataHoraEntrada){
                item.dataEntradaSemHorario = item.dataHoraEntrada.split(" -")[0]
                item.dataEntradaJsDate = this.convertCompleteBrStringToJsDate(item.dataHoraEntrada).getTime()
            }

            if(item.dataCompetencia){
                item.dataCompetenciaJsDate = this.convertCompleteBrStringToJsDate(item.dataCompetencia).getTime()
            }

            if(item.dataHoraImportacao){
                item.dataImportacaoSemHorario = item.dataHoraImportacao.split(" -")[0]
                item.dataHoraImportacaoJsDate = this.convertCompleteBrStringToJsDate(item.dataHoraImportacao).getTime()
            }

            if(item.dataHoraValidacao){
                item.dataHoraValidacaoSemHorario = item.dataHoraValidacao.split(" -")[0]
                item.dataHoraValidacaoJsDate = this.convertCompleteBrStringToJsDate(item.dataHoraValidacao).getTime()
            }

            if(item.dataHoraUltimaAcaoUsuario){
                item.dataHoraUltimaAcaoUsuarioSemHorario = item.dataHoraUltimaAcaoUsuario.split(" -")[0]
                item.dataHoraUltimaAcaoUsuarioJsDate = this.convertCompleteBrStringToJsDate(item.dataHoraUltimaAcaoUsuario).getTime()
            }

        })

    }

    static dealProductData = (productTransactionList) => {

        productTransactionList.forEach(item => {
            
            //Seta Valores Padrão
            item.nf.dataImportacaoSemHorario = ''
            item.nf.dataHoraImportacaoJsDate = ''

            item.nf.dEmiSemHorario = ''
            item.nf.dhEmiJsDate = ''

            item.nf.dataEntradaSemHorario = ''
            item.nf.dataHoraEntradaJsDate = ''

            //Trata código
            if(!item.transaction.productInfo.codigo){
                item.transaction.productInfo.codigo = '' //Troca null por '' para conseguir aparecer no filtro.
            }

            //Trata Tipo de Produto
            if(!item.transaction.productInfo.tipoProduto){
                item.transaction.productInfo.tipoProduto = {descricao: ''}
            }

            //Trata dataHoraImportacao
            if(item.nf.dataHoraImportacao){
                item.nf.dataImportacaoSemHorario = item.nf.dataHoraImportacao.split(" -")[0]
                item.dataHoraImportacaoJsDate = this.convertCompleteBrStringToJsDate(item.nf.dataHoraImportacao).getTime()
            }

            //Trata dhEmi
            if(item.nf.dhEmi){
                item.nf.dEmiSemHorario = item.nf.dhEmi.split(" -")[0]
                item.dhEmiJsDate = this.convertCompleteBrStringToJsDate(item.nf.dhEmi).getTime()
            }

            //Trata dataHoraEntrada
            if(item.nf.dataHoraEntrada){
                item.nf.dataEntradaSemHorario = item.nf.dataHoraEntrada.split(" -")[0]
                item.dataHoraEntradaJsDate = this.convertCompleteBrStringToJsDate(item.nf.dataHoraEntrada).getTime()
            }

        })
    }  
    
    static formatTo2CasasDecimais(valor){
        /*
            Arredonda para 2 casas decimais
        */
       if(!valor){
        valor = 0.00
       }
        return parseFloat(valor.toFixed(2))
    }

    static findTotalItem(list){
        return list.find(item => 
            item.realNome === ConstantsUtil.tipoTotaisFichaBancariaLabel 
            || item.realNome === ConstantsUtil.totalSaldoAnteriorLabel 
            || item.realNome === ConstantsUtil.totalSaldoFinalLabel
        )
    }

    static defineFiltroTipoLancamentoFichaBancaria(obj, isAplicacaoFinanceiraFunc, tipoDeLancamentoState){
        
        if(isAplicacaoFinanceiraFunc()) {
            obj.tipoDeLancamentoBancario = ConstantsUtil.lancamentoBancarioRecebimentoAplicacaoFinanceiraLabel
        }
        else if(tipoDeLancamentoState.includes(ConstantsUtil.lancamentoBancarioTransferenciaLabel)){
            obj.tipoFichaBancaria = ConstantsUtil.tipoFichaBancariaTransferenciaLabel
            if(tipoDeLancamentoState === ConstantsUtil.lancamentoBancarioTransferenciaSaidaLabel){
                obj.tipoDeLancamentoBancario = ConstantsUtil.lancamentoBancarioPagamentoLabel
            }
            else{
                obj.tipoDeLancamentoBancario = ConstantsUtil.lancamentoBancarioRecebimentoLabel
            }
        }
        else{
            obj.tipoDeLancamentoBancario = tipoDeLancamentoState
        }

        return obj
    }

    static isEmptyObject(object){
        return !object || JSON.stringify(object) === '{}'
    }


    searchProvisoes(obj, onSuccess, onFinally, unificar, selectedEmpresas) {

        // console.log("searchProvisoes: ", unificar, selectedEmpresas)

        //Define a função de busca
        let searchInternal = (obj) => {
            if(unificar){
                return this.centralService.searchLancamentosProvisao(obj, selectedEmpresas)
            }
            else{
                return this.provisaoService.searchLancamentos(obj)
            }
        }

        searchInternal(obj)
        .then(async response => {
            let responseData = this.trataDadosSearchProvisoes(response.data)
            onSuccess(responseData)
        })
        .catch(error => {
            // console.log(error)
            HandleErrorService.handleError(error)
        })
        .finally( () => onFinally() )
    }

    trataDadosSearchProvisoes = dados => {

        if(dados.filterTypeDate === ConstantsUtil.dataLancamentoValue) {

            dados.provisaoList.forEach(provisao => {

                provisao.data = provisao.dataLancamento
                provisao.valor = provisao.valorTotal
                provisao.recorrencia = provisao.uuidRecorrencia ? true : false
                provisao.recorrenciaString = provisao.uuidRecorrencia ? 'Sim' : 'Não'

                if(provisao.notaFiscal) {
                    provisao.nomeFornecedor = `${provisao.notaFiscal.fornecedor.nome} (${provisao.notaFiscal.fornecedor.cnpj})`
                    provisao.tipoDePagamento = {
                        nome: provisao.nomeFornecedor,
                        grupoDePagamento: {
                            nome:  ''
                        }
                    }
                }
                else if(provisao.nfse) {
                    provisao.nomeFornecedor = `${provisao.nfse.prestadorServico.nome} (${provisao.nfse.prestadorServico.cnpj})`
                    if(!provisao.tipoDePagamento){
                        provisao.tipoDePagamento = {
                            nome: 'Valor Líquido da NFSe',
                            grupoDePagamento: {
                                nome:  ''
                            }
                        }                    
                    }
                }
                else if(provisao.tipoDePagamento && provisao.tipoDePagamento.fornecedor) {
                    provisao.nomeFornecedor = provisao.tipoDePagamento.fornecedor.nome
                }
                else {
                    provisao.nomeFornecedor = ""
                }

                this.preencheTipoDePagamentoNuloComNomeFornecedor(provisao)

                this.reescreveOrigemProvisao(provisao)

            })
        }

        else if(
            dados.filterTypeDate === ConstantsUtil.dataPagamentoValue
            || dados.filterTypeDate === ConstantsUtil.dataVencimentoValue
        ) {

            dados.parcelaProvisaoList.forEach(parcelaProvisao => {

                parcelaProvisao.recorrencia = parcelaProvisao.uuidRecorrenciaProvisao ? true : false
                parcelaProvisao.recorrenciaString = parcelaProvisao.uuidRecorrenciaProvisao ? 'Sim' : 'Não'
                
                this.preencheTipoDePagamentoNuloComNomeFornecedor(parcelaProvisao)

                this.reescreveOrigemProvisao(parcelaProvisao)

            })


        }

        let valorTotal = this.calculaValorTotalSearchProvisoes(dados)
        
        return {dados, valorTotal};

    }

    preencheTipoDePagamentoNuloComNomeFornecedor(provisaoOuParcela){
        // sem tipo de pagamento: usa o nome do fornecedor no lugar (ou vazio, pra não quebrar a tabela)
        if(!provisaoOuParcela.tipoDePagamento && provisaoOuParcela.nomeFornecedor){
            provisaoOuParcela.tipoDePagamento = {
                nome: provisaoOuParcela.nomeFornecedor,
                grupoDePagamento: {
                    nome:  ''
                }
            }
        }
    }

    reescreveOrigemProvisao(provisaoOuParcela){
        if(provisaoOuParcela.origem){
            switch(provisaoOuParcela.origem){
                case ConstantsUtil.origemProvisaoImportacaoNF:
                    provisaoOuParcela.origem = ConstantsUtil.origemProvisaoImportacaoNFLabel
                    break;
                case ConstantsUtil.origemProvisaoImportacaoNFSe:
                    provisaoOuParcela.origem = ConstantsUtil.origemProvisaoImportacaoNFSeLabel
                    break;
                case ConstantsUtil.origemProvisaoNFManual:
                    provisaoOuParcela.origem = ConstantsUtil.origemProvisaoNFManualLabel
                    break;
                case ConstantsUtil.origemProvisaoOutroasProvisoesManuais:
                    provisaoOuParcela.origem = ConstantsUtil.origemProvisaoOutroasProvisoesManuaisLabel
                    break;
            }
        }
    }
    
    calculaValorTotalSearchProvisoes = (dados) => {

        let valorTotal = 0

        if(dados.filterTypeDate === ConstantsUtil.dataLancamentoValue){
            dados.provisaoList.forEach(provisao => valorTotal += provisao.valorTotal)
        }
        else if(dados.filterTypeDate === ConstantsUtil.dataPagamentoValue){
            dados.parcelaProvisaoList.forEach(parcelaProvisao => valorTotal += parcelaProvisao.valor)
        }

        valorTotal = GeneralServices.formatTo2CasasDecimais(valorTotal)

        return valorTotal;

    }

    getEmpresasInASelectList = (onSuccess, onError) => {
        this.empresaService.getLoggedEmpresas()
        .then(response => {
            var list = []
            response.data.forEach(empresa => {
                list.push({label: empresa.nome, value: empresa})
            });
            
            if(onSuccess){
                onSuccess(list)
            }

        })
        .catch(error => {
            HandleErrorService.handleError(error)
            if(onError){
                onError(error)
            }
        })
    }

    getLoggedSystemData(onSuccess, onError){
        this.systemDataService.getLoggedSystemData()
        .then(response => {
            onSuccess(response)
        })
        .catch(error => {
            HandleErrorService.handleError(error)
            if(onError){
                onError()
            }
        })
    }

    static renderStyledSituacaoTableColumn = (rowData) => {

        const classes = classNames({
            'superavitValue': rowData.ativo,
            'deficitValue': !rowData.ativo
        });

        return (
            <div className={classes}>
                {rowData.ativo ? 'ATIVO' : 'INATIVO'}
            </div>
        );
    }

    static renderStyledSituacaoNF = (situacaoLabel, rowIndex, onClickFunction) => {

        let isLink = situacaoLabel === ConstantsUtil.situacaoExcluidaLabel

        const classes = classNames({
            'superavitValue': situacaoLabel === ConstantsUtil.situacaoRegularValidadaLabel,
            'deficitValue': [ConstantsUtil.situacaoExcluidaLabel, ConstantsUtil.situacaoCanceladaLabel].includes(situacaoLabel),
            'linkValue': isLink
        });

        if(isLink){
            return (
                <>
                    <a 
                        className={classes}
                        onClick={onClickFunction}
                    >
                        {this.renderBodyColumnInOneLine(situacaoLabel, rowIndex)}
                    </a>
                </>
            )
        }

        return (
            <div className={classes}>
                {this.renderBodyColumnInOneLine(situacaoLabel, rowIndex)}
            </div>
        );
    }

    static renderStyledNF = (value, isLink, rowIndex, onClickFunction) => {
        const classes = classNames({
            // 'superavitValue': situacaoLabel === ConstantsUtil.situacaoRegularValidadaLabel,
            'deficitValue': isLink,
            'linkValue': isLink
        });

        if(isLink){
            return (
                <>
                    <a 
                        className={classes}
                        onClick={onClickFunction}
                    >
                        {this.renderBodyColumnInOneLine(value, rowIndex)}
                    </a>
                </>
            )
        }

        return (
            <div className={classes}>
                {this.renderBodyColumnInOneLine(value, rowIndex)}
            </div>
        );
    }

    static renderStyledTipoCriacaoNF = (notaFiscal, rowIndex, onClickFunction) => {
        let isLink = (notaFiscal.tipoCriacao === ConstantsUtil.nfManualLabel)
        return this.renderStyledNF(notaFiscal.tipoCriacao, isLink, rowIndex, onClickFunction)
    }

    static renderStyledTipoNF = (notaFiscal, rowIndex, onClickFunction) => {
        
        let isLink = (notaFiscal.tipo === ConstantsUtil.tipoNFDevolucaoEntradaLabel) || (notaFiscal.valorDescontoPorDevolucao)

        return this.renderStyledNF(notaFiscal.tipo, isLink, rowIndex, onClickFunction)

    }

    static renderStyledColorTableColumn = (value, checked) => {
        const classes = classNames({
            'superavitValue': checked,
            'deficitValue': !checked
        });

        return (
            <div className={classes}>
                {value}
            </div>
        );        
    }

    static renderBodyColumnInOneLine = (value, rowIndex, title) => {
        /*
        Faz com que o valor da coluna da tabela fique em única linha, ocultando se passar do width da coluna.
        Ainda, caso o usuário passe o mouse sobre a linha, conseguirá ver o valor completo da coluna através de um title
        */
        const uniqueId = `name_${rowIndex.rowIndex}`;
        return(
            <div
                style ={ {
                    whiteSpace: 'nowrap', /* Impede que o texto quebre em várias linhas */
                    overflow: 'hidden', /* Esconde qualquer conteúdo que exceda o width da coluna */
                    textOverflow: 'ellipsis', /* Adiciona reticências (...) ao final do texto cortado */
                } }
                title={title ? title : value}
            >

                <span id={uniqueId}>{value}</span>

            </div>
        );
    }

    static renderTableValueAsLink = (rowData, rowIndex, valor, deveRenderizarEstaLinhaComoLink, isDeficitValue, actionFunction) => {
        if( deveRenderizarEstaLinhaComoLink ){
            const classes = classNames({
                'deficitValue': isDeficitValue,
                'linkValue': true
                
            });
            // const uniqueId = `name_${rowIndex.rowIndex}`;
            return(
                <a 
                    className={classes}
                    // style ={ {
                    //     whiteSpace: 'nowrap', /* Impede que o texto quebre em várias linhas */
                    //     overflow: 'hidden', /* Esconde qualquer conteúdo que exceda o width da coluna */
                    //     textOverflow: 'ellipsis', /* Adiciona reticências (...) ao final do texto cortado */
                    // } }                    
                    onClick={() => actionFunction(rowData)}
                >
                    {valor}
                    {/* <span id={uniqueId}>{valor}</span> */}
                </a>
            )
        }
        else{
            return(
                <>
                    {valor}
                </>
            )
        }        
    }


    static filtraOcultaExcluidas = async (setStateFunction, field, dataTableRef) => {
        let sitacaoNFNaoExluidaList = [ConstantsUtil.situacaoRegularValidadaLabel, ConstantsUtil.situacaoRegularAguardandoValidacaoLabel]
        setStateFunction(sitacaoNFNaoExluidaList)
        dataTableRef.current.filter(sitacaoNFNaoExluidaList, field, 'in');

    }
    
    static getTipoDeProdutoOuEstoqueLabel(tipo){
        switch(tipo){
            case ConstantsUtil.inputTipoProduto:
                return ConstantsUtil.tipoDeProdutoLabel
            case ConstantsUtil.inputTipoEstoque:
                return ConstantsUtil.tipoDeEstoqueLabel
        }        
    }

    static getEditarTipoProdutoOuEstoqueLabel(tipo){
        return this.getCadastrarTipoProdutoOuEstoqueLabel(tipo).replace("Cadastrar", "Editar")
    }

    static getCadastrarTipoProdutoOuEstoqueLabel(tipo){
        switch(tipo){
            case ConstantsUtil.inputTipoProduto:
                return ConstantsUtil.cadastrarTipoDeProdutoLabel
            case ConstantsUtil.inputTipoEstoque:
                return ConstantsUtil.cadastrarTipoDeEstoqueLabel
        }
    }

    static formataTipoDeAtualizacaoFichaDeEstoque(itemFichaDeEstoque){

        const hashtag = "#"
        const entrada = "entrada"
        const saida = "saída"
        const manual = "manual"
        
        // console.log("itemFichaDeEstoque: ", itemFichaDeEstoque)
        let complementoAtualizacaoProcessamento = ""
        if(itemFichaDeEstoque.possuiEntradaManual || itemFichaDeEstoque.possuiSaidaManual){
            complementoAtualizacaoProcessamento += ` (possui ${hashtag} ${manual})`
        }

        if(itemFichaDeEstoque.possuiEntradaManual){
            complementoAtualizacaoProcessamento = complementoAtualizacaoProcessamento.replace(hashtag, entrada)
        }
        if(itemFichaDeEstoque.possuiSaidaManual){
            if(complementoAtualizacaoProcessamento.includes(hashtag)){
                complementoAtualizacaoProcessamento = complementoAtualizacaoProcessamento.replace(hashtag, saida)
            }
            else{
                //tem "entrada"
                complementoAtualizacaoProcessamento = complementoAtualizacaoProcessamento.replace(entrada, `${entrada} e ${saida}`)
                complementoAtualizacaoProcessamento = complementoAtualizacaoProcessamento.replace(manual, "manuais")
            }
        }

        if(!itemFichaDeEstoque.tipoAtualizacao){
            return ''
        }
        let deParaList = [
            {tipo: 'PROCESSAMENTO_DO_SISTEMA_MESMA_DATA_DO_MANUAL_HORARIO_ANTERIOR', tipoFormatado: 'Processamento do sistema em horário anterior à atualização manual' + complementoAtualizacaoProcessamento},
            {tipo: 'MANUAL', tipoFormatado: 'Atualização manual'},
            {tipo: 'PROCESSAMENTO_DO_SISTEMA', tipoFormatado: 'Processamento do sistema' + complementoAtualizacaoProcessamento},
            {tipo: 'AJUSTE_PERDA', tipoFormatado: 'Ajuste perda'},
            {tipo: 'AJUSTE_SOBRA', tipoFormatado: 'Ajuste sobra'},
            {tipo: 'DEVOLUCAO', tipoFormatado: 'Devolução'},
        ]

        deParaList.forEach(dePara => {
            if(itemFichaDeEstoque.tipoAtualizacao === dePara.tipo){
                itemFichaDeEstoque.tipoAtualizacaoFormatado = itemFichaDeEstoque.tipoAtualizacao.replace(dePara.tipo, dePara.tipoFormatado)
                return;
            }
        })
        return itemFichaDeEstoque.tipoAtualizacaoFormatado

    }

    static porcentagemColunaTabelaMesesConsolidados = (qtdMeses, tipoColuna) => {
        
        let pNome = 1.2
        let pPorcentagem = 0.7
        let tamanhoColunaMes = 100/(pNome + pPorcentagem + qtdMeses + 1)

        let tamanhoColunaFinal

        switch(tipoColuna){
            case ConstantsUtil.tipoColunaNome:
                tamanhoColunaFinal = pNome*tamanhoColunaMes
                break;
            case ConstantsUtil.tipoColunaMes:
                tamanhoColunaFinal = tamanhoColunaMes
                break;
            case ConstantsUtil.tipoColunaPorcentagem:
                tamanhoColunaFinal = pPorcentagem*tamanhoColunaMes
                break;
        }
        let resultado = `${tamanhoColunaFinal}%`
        // console.log("resultado: ", resultado)
        return resultado

    }

    static calcularMeses(dataInicial, dataFinal) {
        
        // console.log(dataInicial, dataFinal)

        /*
        Considera que as datas informadas estão no padrão dd-MM-yyyy.
        */

        const [dia, mes, ano] = dataInicial.split('-');
        const inicio = new Date(`${ano}-${mes}-01`);
        
        const [dia2, mes2, ano2] = dataFinal.split('-');
        const fim = new Date(`${ano2}-${mes2}-01`);
        
        const meses = (fim.getFullYear() - inicio.getFullYear()) * 12 + (fim.getMonth() - inicio.getMonth()) + 1;
        
        // console.log("meses: ", meses)
        return meses;
    }

    static formataCpfCnpj(cpfOuCnpj){

        if(!cpfOuCnpj){
            return ''
        }

        cpfOuCnpj = cpfOuCnpj.replace(/[^0-9]/g, '');

        if (cpfOuCnpj.length === 11) {
          // CPF
          return cpfOuCnpj.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
        } else if (cpfOuCnpj.length === 14) {
          // CNPJ
          return cpfOuCnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
        } else {
          return cpfOuCnpj;
        }        
    }

    completaLogin(user, context, specificPathName, shouldReload = false){

        context.beginSession(user)

        const buscaConfiguracaoEmpresa = this.configuracaoEmpresaService.search()
        .then(response => {
            user.configuracaoEmpresa = response.data
            // console.log("completaLogin: ", user)
        })
        .catch(error => {
            HandleErrorService.handleError(error)
        })

        const buscaPreferenciasUsuario = this.preferenciasUsuarioService.buscarPreferencias()
        .then(response => {
            // console.log("preferencias response: ", response.data)
            user.preferenciasUsuario = response.data
        })
        .catch(error => {
            HandleErrorService.handleError(error)
        })

        Promise.all([buscaConfiguracaoEmpresa, buscaPreferenciasUsuario])
        .finally(() => {

            if(shouldReload){
                window.location.reload()
            }

            context.beginSession(user)
            if(specificPathName){
                return
            }

            let { redirectPath } = this.props ? this.props.match.params : '';
            if(redirectPath){
                window.location = `/${redirectPath}`
            }
            else{
                window.location.href = ConstantsUtil.homePathname
            }
        })

    }

    static isTelaPreValidacaoNFs(){
        return window.location.pathname === ConstantsUtil.preValidacaoNFsEntrada
    }

    static centralizaLabel(label){
        return (
            <div className='centraliza-conteudo-div'>{label}</div>
        )        
    }

    static obterIntervaloFromDescricaoMes(descricaoMesAno) {
        const meses = {
            Jan: 0,
            Fev: 1,
            Mar: 2,
            Abr: 3,
            Mai: 4,
            Jun: 5,
            Jul: 6,
            Ago: 7,
            Set: 8,
            Out: 9,
            Nov: 10,
            Dez: 11
        };

        const [mesAbreviado, anoStr] = descricaoMesAno.split("-");
        const mes = meses[mesAbreviado];
        const ano = parseInt(anoStr, 10);

        if (mes === undefined || isNaN(ano)) {
            throw new Error("Formato inválido. Use o formato 'Abr-2025'.");
        }

        const inicio = new Date(ano, mes, 1);
        const fim = new Date(ano, mes + 1, 0); // último dia do mês

        const formatar = (data) => {
            const dia = String(data.getDate()).padStart(2, "0");
            const mes = String(data.getMonth() + 1).padStart(2, "0");
            const ano = data.getFullYear();
            return `${dia}-${mes}-${ano}`;
        };

        return {
            inicio: formatar(inicio),
            fim: formatar(fim)
        };
    }

    buscaComponenteDigital = (idComponenteDigital) => {
        AuthService.startBlockUi()
        this.componenteDigitalService.buscaComponenteDigital(idComponenteDigital)
        .then(response => {
            let componenteDigital = response.data
            // console.log("componenteDigital: ", componenteDigital)
            this.abrirOuBaixarArquivoBase64(componenteDigital)
        })
        .catch(error => {
            HandleErrorService.handleError(error)
        })
        .finally(() => {
            AuthService.stopBlockUi()
        })
    }

    static transformaAquivoEmBase64 = (file, onloadFunction) => {

        const reader = new FileReader();

        //Define a função onload que será usada dentro de readAsDataURL
        reader.onload = () => {
            onloadFunction(reader)
        }

        reader.readAsDataURL(file);

    }

    abrirOuBaixarArquivoBase64 = (componenteDigital) => {
        
        let arquivoBase64 = componenteDigital.arquivoBase64
        let nomeArquivoComExtensao = componenteDigital.nomeArquivoComExtensao
        let isPdf = nomeArquivoComExtensao.endsWith(ConstantsUtil.extensaoPdf)

        let bytes = this.base64ToUint8Array(arquivoBase64);
        const mimeType = isPdf ? 'application/pdf' : 'application/octet-stream';
        const blob = new Blob([bytes], { type: mimeType });
        const blobUrl = URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = blobUrl;

        if (isPdf) {
            // Abrir em nova aba
            link.target = '_blank';
            link.rel = 'noopener';
            link.type = 'application/pdf';
        } else {
            // Forçar download
            link.download = nomeArquivoComExtensao;
        }

        document.body.appendChild(link);
        link.click();
        link.remove();

        // Revoga URL após 10s para liberar memória
        setTimeout(() => URL.revokeObjectURL(blobUrl), 10000);
    }

    // abrePdfNovaAba = (arquivoBase64) => {
    //     let bytes = this.base64ToUint8Array(arquivoBase64)
    //     const blob = new Blob([bytes], { type: 'application/pdf' });
    //     const blobUrl = URL.createObjectURL(blob);

    //     // Tenta abrir nova aba
    //     // const novaAba = window.open(blobUrl, '_blank', 'noopener');

    //     // Evita bloqueio de pop-up: cria link e clica programaticamente
    //     const link = document.createElement('a');
    //     link.href = blobUrl;
    //     link.target = '_blank'; //para abrir em nova aba
    //     // link.download = 'file.pdf' //para download
    //     link.rel = 'noopener';
    //     link.type = 'application/pdf';
    //     document.body.appendChild(link);
    //     link.click();
    //     link.remove();

    //     // Revoga URL após 10s
    //     setTimeout(() => URL.revokeObjectURL(blobUrl), 10000);
        
    // }

    base64ToUint8Array(arquivoBase64) {
        const binaryString = atob(arquivoBase64); // decodifica base64 para string binária
        const len = binaryString.length;
        const bytes = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }
        return bytes;
    }

    static callAbrirFiltroNome(labelFiltro, timeout){
        // console.log(labelFiltro, timeout)
        setTimeout(
            () => GeneralServices.abrirFiltroNome(labelFiltro),
            timeout
        )
    }    

    static abrirFiltroNome(labelFiltro) {
        // pega todas as labels dos MultiSelect
        var labels = document.querySelectorAll('.p-multiselect-label.p-placeholder');

        for (var i = 0; i < labels.length; i++) {
            var label = labels[i];

            // procura a label "Nome"
            if (label.textContent.trim() === labelFiltro) {
                // sobe para o container do MultiSelect
                var container = label.closest('.p-multiselect');
                if (!container) continue;

                // pega o botão que abre o dropdown
                var trigger = container.querySelector('.p-multiselect-trigger');
                if (!trigger) continue;

                // simula o clique
                trigger.click();
                break; // abre só o primeiro encontrado
            }
        }
    }

    static alteraImpostosRetidosNfse = (event, Nfse) => {
        
        const name = event.target.name
        
        Nfse.impostoRetidoValorPIS = Nfse.impostoRetidoValorPIS ? Nfse.impostoRetidoValorPIS : 0
        Nfse.impostoRetidoValorCOFINS = Nfse.impostoRetidoValorCOFINS ? Nfse.impostoRetidoValorCOFINS : 0
        Nfse.impostoRetidoValorINSS = Nfse.impostoRetidoValorINSS ? Nfse.impostoRetidoValorINSS : 0
        Nfse.impostoRetidoValorIR = Nfse.impostoRetidoValorIR ? Nfse.impostoRetidoValorIR : 0
        Nfse.impostoRetidoValorCSLL = Nfse.impostoRetidoValorCSLL ? Nfse.impostoRetidoValorCSLL : 0
        Nfse.impostoRetidoValorISS = Nfse.impostoRetidoValorISS ? Nfse.impostoRetidoValorISS : 0

        let previousValue = Nfse[name]
        Nfse[name] = event.value
        
        let valorLiquido =
            Nfse.valorBruto
            - Nfse.impostoRetidoValorPIS
            - Nfse.impostoRetidoValorCOFINS
            - Nfse.impostoRetidoValorINSS
            - Nfse.impostoRetidoValorIR
            - Nfse.impostoRetidoValorCSLL
            - Nfse.impostoRetidoValorISS

        if(valorLiquido < 0){
            popUp.infoPopUp("Valor dos Impostos Retidos ultrapassou Valor Bruto.")
            return Nfse;
        }

        Nfse.valorLiquido = valorLiquido
        
        // console.log("Nfse: ", Nfse)
        // console.log("\n\n\n")

        return Nfse
    }

    static parseNfseImpostosRetidos = NfseOriginal => {
        
        let Nfse = {...NfseOriginal}
        Nfse.valorPis = Nfse.impostoRetidoValorPIS
        Nfse.valorCofins = Nfse.impostoRetidoValorCOFINS
        Nfse.valorInss = Nfse.impostoRetidoValorINSS
        Nfse.valorIr = Nfse.impostoRetidoValorIR
        Nfse.valorCsll = Nfse.impostoRetidoValorCSLL
        Nfse.valorIss = Nfse.impostoRetidoValorISS

        // console.log("parseNfseImpostosRetidos generalServices: ", Nfse)

        return Nfse

    }
    
    static getNomeSemSimboloGrupoDre = (nomeGrupo) => {
        return nomeGrupo.split(") ")[1]
    }

    static getDatasPagamentosRecorrenciasFuturas = (provisoesRecorrentesFuturas) => {
        let datas = provisoesRecorrentesFuturas.map(provisaoFutura => provisaoFutura.parcelaProvisaoList[0].data)
        return (
            <div style={{ display: 'block', marginTop: '8px', textAlign: 'left' }}>
                <ul style={{ paddingLeft: '20px', margin: 0 }}>
                    {datas.map((data, index) => (
                        <li key={index}>{data}</li>
                    ))}
                </ul>
            </div>
        );    
    }

}

export default GeneralServices